import axios from "axios";
import "../src/assets/style.css";
import "../src/assets/responsive.css";
import {createVuetify} from "./vuetify";
import { useEnvConfigStore } from "../src/store/env.store";
import { globalRegisteredComponents } from "../src/globalComponents/GlobalComponents";
import '@globalhive/vuejs-tour/dist/style.css';
import VueTheMask from "vue-the-mask";

import { createApp } from "vue";
import { createPinia } from "pinia";
import Vue3Toastify, { toast, type ToastContainerOptions } from 'vue3-toastify';


import App from "./App.vue";
import router from "./router";
import { useGlobalStore } from "./store/globalStore";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
let keys:any = {}

async function initApp() {
const app = createApp(App);

// The Pinia store is added globally
const pinia = createPinia();
app.use(pinia);
pinia.use(piniaPluginPersistedstate)


const {getUserMetaData} = useGlobalStore()

 // An environment variable is dynamically changed
await  axios
 .get("/env-config.json")
 .then((response) => {
   keys = response.data;
 })
 .catch((e) => {})
 .finally(()=> {})

useEnvConfigStore().setApiUrls(keys);

//Get user meta data
await getUserMetaData()

// Vuetify is added globally
const vuetify = createVuetify()
app.use(vuetify);

//Vue Router added
app.use(router);

 // VueTheMask is added globally
 app.use(VueTheMask);

// Components are registered globally
globalRegisteredComponents(app);

//Todo
app.use(Vue3Toastify,{
      closeOnClick: true,  
      pauseOnHover: true,
      hideProgressBar: false,
      position: toast.POSITION.TOP_RIGHT,
      style: {
        fontSize: '12px',
        padding: '10px 12px',     
        minHeight: '10px',       
        maxWidth: 'none',       
        width: 'auto',         
        right: '0',
        left: 'auto',
        whiteSpace: 'nowrap', 
        height: '5px'
      },
      containerStyle: {
        top: '10px',
        right: '10px',
        left: 'auto',
        position: 'fixed',
        transform: 'none'
      },
} as ToastContainerOptions);


app.mount("#app");

}

initApp()